import React, { useEffect } from "react";
import MainLayout from "../component/shared/layout/MainLayout";
import LadyComponent from "../component/shared/LadyComponent/LadyComponent";
import CertifiedComponent from "../component/shared/Certified/CertifiedComponent";
import FreeQuoteToday from "../component/shared/FreeQuote/FreeQuoteToday";
import ServicesPageTopComponent from "../component/shared/ServicesPageTopComponent/ServicesPageTopComponent";

import MadeFrom from "../component/shared/MadeFrom/MadeFrom";
import ServicesInfo from "../component/shared/ServicesInfo/ServicesInfo";
import ServicesInfoTwo from "../component/shared/ServicesInfoTwo/ServicesInfoTwo";
import PageTitle from "../component/shared/PageTitle/PageTitle";
import SharedOurValueComponent from "../component/shared/SharedOurValueComponent/SharedOurValueComponent";
import ButtonContact from "../component/shared/ButtonContact/ButtonContact";
import {
  madeFromSpray,
  second_info,
  service_spray,
  servies_info,
  titleSpray,
  values,
} from "../Services/ServicesSpray";
import { useLocation } from "react-router-dom";

function ServicesSprayFoam() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <MainLayout>
        <ServicesPageTopComponent pageData={service_spray} />
        <ServicesInfo first={servies_info} />
        <ServicesInfoTwo second={second_info} />
        <PageTitle title={titleSpray} />
        <SharedOurValueComponent values={values} />
        <ButtonContact />
        <MadeFrom madefrom={madeFromSpray} />
        <LadyComponent />
        <CertifiedComponent />
        <FreeQuoteToday />
      </MainLayout>
    </div>
  );
}

export default ServicesSprayFoam;
